/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const GDPRConsentLevel = {
    None: 'none',
    Necessary: 'necessary',
    Analytics: 'analytics',
    Marketing: 'marketing',
    Retargeting: 'retargeting',
    Tracking: 'tracking'
} as const;
export type GDPRConsentLevel = typeof GDPRConsentLevel[keyof typeof GDPRConsentLevel];


export function GDPRConsentLevelFromJSON(json: any): GDPRConsentLevel {
    return GDPRConsentLevelFromJSONTyped(json, false);
}

export function GDPRConsentLevelFromJSONTyped(json: any, ignoreDiscriminator: boolean): GDPRConsentLevel {
    return json as GDPRConsentLevel;
}

export function GDPRConsentLevelToJSON(value?: GDPRConsentLevel | null): any {
    return value as any;
}

